<template>
  <!-- 帮帮-发布服务 -->
  <div class="firm-body">
    <div class="help-body">
      <!-- 标题 帮帮-店铺管理 发布服务-->
      <p class="title-Individual-center">
        <span class="firm-clickable" @click="handelBackTable">店铺管理</span>
        <i class="el-icon-arrow-right"></i
        ><span class="firm-clickable" @click="handelBackTable">订单管理</span>
        <i class="el-icon-arrow-right"></i>
        <span v-if="Back == '1'" @click="handelBackTable">服务商</span>
        <span v-if="Back == '2'" @click="handelBackTable">需求订单</span>
        <i class="el-icon-arrow-right"></i>
        <span class="span-Individual-center">确认合同</span>
      </p>
      <!-- 内容 -->
      <div class="help-Content">
        <!-- 确认合同-->
        <div class="top-title">
          <p class="title">确认合同</p>
          <div class="Back" @click="handelBack">
            <div class="Back-style">
              <div></div>
              <p>返回</p>
            </div>
          </div>
        </div>
        <div class="contract-Preview"></div>
        <!-- 确认并发送合同 -->
        <div class="btn-box">
          <p v-if="Back == '1'" @click="handelVerify">确认并发送合同</p>
          <p v-if="Back == '2'" @click="handelVerify">确认</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      Back: "", // 从合同确认页面返回时返回那个页面 1返回合同编辑  2返回签合同
    };
  },
  watch: {},
  components: {},
  created() {
    if (this.$route.query.key != "" && this.$route.query.key != undefined) {
      this.Back = this.$route.query.key;
    }
  },
  destroyed() {},

  methods: {
    // 面包屑 跳转
    handelBackTable() {
      if (this.Back == "1") {
        this.$router.push({
          path: "/HelpShop/ShopOrderSingle",
          query: { key: 1 },
        });
      } else if (this.Back == "2") {
        this.$router.push({
          path: "/HelpShop/ShopOrderSingle",
          query: { key: 2 },
        });
      }
    },
    // 确认发送合同
    handelVerify() {
      if (this.Back == "1") {
        // 存入select 返回/HelpShop的同时获取到select  select中的数就是该页面所在的位置
        this.$router.push({
          path: "/HelpShop",
          // query: { key: 1 },
        });
      } else if (this.Back == "2") {
        // 存入select 返回/HelpShop的同时获取到select  select中的数就是该页面所在的位置
        this.$router.push({
          path: "/HelpShop",
        });
      }
    },
    // 返回
    handelBack() {
      // ==1 返回合同编辑页面
      if (this.Back == "1") {
        this.$router.push({
          path: "/HelpShop/QuasiContract",
        });
      } else if (this.Back == "2") {
        this.$router.push({
          path: "/HelpShop/SignContract",
        });
      }
    },
  },
};
</script>

<style scoped lang="less">
.el-icon-arrow-right {
  margin-left: 4px;
  margin-right: 4px;
}
.firm-body {
  width: 100%;
  flex: 1;
  height: 100%;
  display: flex;
  .help-body {
    min-width: 1200px;
    margin: 0 auto;
    margin-top: 20px;
    display: flex;
    flex-direction: column;
  }
}
//主体
.help-Content {
  min-width: 1140px;
  height: 100%;
  background: #ffffff;
  box-shadow: 0px 0px 3px 0px rgba(125, 125, 125, 0.5);
  border-radius: 5px;
  margin-top: 13px;
  margin-bottom: 20px;
  padding: 30px;
  font-weight: 400;
  font-size: 14px;
  color: #333333;
  font-family: PingFangSC-Medium;
  // 标题
  .top-title {
    width: 100%;
    height: 40px;
    display: flex;
    position: relative;
    .title {
      width: 300px;
      height: 40px;
      line-height: 40px;
      background: #409eff ;
      border-radius: 10px;
      font-family: PingFangSC-Medium;
      font-size: 16px;
      color: #ffffff;
      text-align: center;
      font-weight: 400;
      margin: auto;
    }
    .Back {
      width: 110px;
      height: 30px;
      background: rgba(97, 144, 232, 0.3);
      border-radius: 5px;
      display: flex;
      position: absolute;
      right: 0;
      top: 5px;
      cursor: pointer;
      .Back-style {
        width: 50px;
        height: 17px;
        line-height: 17px;
        margin: auto;
        display: flex;
        div {
          width: 14px;
          height: 17px;
          background-image: url("../../../../../assets/imgs/back-da@3x.svg");
          background-size: 100% 100%;
        }
        p {
          font-size: 14px;
          color: #409eff ;
          margin-left: 5px;
          cursor: pointer;
        }
      }
    }
  }
  // 合同
  .contract-Preview {
    width: 550px;
    height: 710px;
    border: 1px solid gold;

    margin: 0 auto;
    margin-top: 50px;
  }
}

.btn-box {
  width: 100%;
  height: 40px;
  display: flex;
  justify-content: flex-end;
  margin-top: 50px;
  p {
    width: 160px;
    height: 40px;
    line-height: 40px;
    background: #409eff ;
    border-radius: 5px;
    font-size: 16px;
    color: #ffffff;
    text-align: center;
    cursor: pointer;
  }
}
</style>
